import React, { useEffect, useState } from 'react';
import { supabase, SimulationReport } from '../../lib/supabase';
import { useAuthStore } from '../../lib/store-auth';
import { useReportStore } from '../../lib/store-report';

interface PastSessionsProps {
    onBack: () => void;
    userId?: string; // Optional user ID for admin view
    onViewReport?: () => void;
}

export const PastSessions: React.FC<PastSessionsProps> = ({ onBack, userId, onViewReport }) => {
    const { user: currentUser } = useAuthStore();
    const { setReport } = useReportStore();
    const [reports, setReports] = useState<SimulationReport[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    // Use passed userId or current user's id
    const targetUserId = userId || currentUser?.id;

    useEffect(() => {
        const fetchReports = async () => {
            if (!targetUserId || !supabase) return;

            try {
                const { data, error } = await supabase
                    .from('simulation_reports')
                    .select('*')
                    .eq('user_id', targetUserId)
                    .order('created_at', { ascending: false });

                if (error) {
                    throw error;
                }

                setReports(data || []);
            } catch (err: any) {
                console.error("Raporlar yüklenirken hata:", err);
                setError("Raporlar yüklenirken bir hata oluştu.");
            } finally {
                setLoading(false);
            }
        };

        fetchReports();
    }, [targetUserId]);

    const handleViewReport = (report: SimulationReport) => {
        // ReportStore'a veriyi yükle ve raporu aç
        // Not: App.tsx'de view değişimi için bir callback gerekebilir veya
        // ReportStore'daki showReport flag'i kullanılabilir.
        // Şimdilik sadece store'a set ediyoruz.
        setReport(report.report_data);
        if (onViewReport) {
            onViewReport();
        }
    };

    if (loading) return <div className="loading-spinner">Yükleniyor...</div>;

    return (
        <div className="past-sessions-container" style={{ padding: '20px', overflowY: 'auto', height: '100%' }}>
            <div className="header" style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                <button onClick={onBack} className="back-btn" style={{ marginRight: '10px', background: 'none', border: 'none', cursor: 'pointer' }}>
                    <span className="material-symbols-outlined">arrow_back</span>
                </button>
            </div>

            {error && <div className="error-message">{error}</div>}

            {reports.length === 0 ? (
                <div className="empty-state">
                    <p>Henüz kayıtlı bir oturumunuz bulunmuyor.</p>
                </div>
            ) : (
                <div className="reports-grid" style={{ display: 'grid', gap: '15px' }}>
                    {reports.map((report) => (
                        <div key={report.id} className="report-card" style={{
                            background: 'white',
                            padding: '15px',
                            borderRadius: '12px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                            <div className="report-info">
                                <h3 style={{ margin: '0 0 5px 0', fontSize: '16px' }}>{report.simulation_title || 'İsimsiz Simülasyon'}</h3>
                                <div className="meta" style={{ color: '#666', fontSize: '12px' }}>
                                    <span style={{ marginRight: '15px' }}>
                                        {new Date(report.created_at).toLocaleDateString('tr-TR')} {new Date(report.created_at).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}
                                    </span>
                                    <span>Puan: <strong>{report.score || '-'}</strong></span>
                                </div>
                            </div>
                            <button
                                onClick={() => handleViewReport(report)}
                                className="view-btn"
                                style={{
                                    background: '#7c4dff',
                                    color: 'white',
                                    border: 'none',
                                    padding: '8px 16px',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    fontWeight: 500
                                }}
                            >
                                Raporu Gör
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
